function fetchWithThrow(url, options) {
  return fetch(url, options).then(response => {
    if (!response.ok) {
      return response.text().then(text => {
        const error = new Error(response.statusText || 'HTTP error');
        error.status = response.status;
        error.statusText = response.statusText;

        try {
          error.data = text ? JSON.parse(text) : null;
        } catch (e) {
          error.data = text || null;
        }

        throw error;
      });
    }

    // Check content type and length
    const contentType = response.headers.get('content-type');
    const contentLength = response.headers.get('content-length');

    // If no content or not JSON, return null
    if (contentLength === '0' || !contentType?.includes('application/json')) {
      return null;
    }

    return response.text().then(text => {
      try {
        return text ? JSON.parse(text) : null;
      } catch (e) {
        return null;
      }
    });
  });
}

export default fetchWithThrow;
